import CancelablePromise from 'mn-utils/CancelablePromise';
import {TResponse, TUUID} from '@/types';

import {get, post} from '../../http';

import {TListItem, TCreateParams, TUpdateParams} from './types';
import {apiV2CryptoAccountGet} from './mock';

export function apiV2AppGet(params: {id: TUUID}): Promise<TListItem> {
  const url = '/f2c/v1/console/app/item/' + params.id;
  if (process.env.MOCK) {
    const response = apiV2CryptoAccountGet();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url, params);
}

export function apiV2AppCreate(params: TCreateParams): Promise<TResponse> {
  const url = '/f2c/v1/console/app/create';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// Обновить информацию по банку
export function apiV2AppUpdate(params: TUpdateParams): Promise<TResponse> {
  const url = '/f2c/v1/console/app/update';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}
